import {Base} from "@/dto/Base";
import {JiGuangRenZhengVo} from "@/entity/JiGuangRenZhengVo";

export class JiGuangRenZhengDto {
    public static url='/jiGuangRenZheng'
    public static url1 ='/auth'
    public static async getPhoneByJVerify(jiGuangRenZhengVo: JiGuangRenZhengVo){
        const response = await  Base.post(this.url+'/getPhoneByJVerify',jiGuangRenZhengVo)as any;
        return response.data as any;
    }
    public static async oneClickLogin(userName: string){
        const response = Base.getData(this.url1+'/oneClickLogin'+'?userName=' + userName);
        return response
    }
}
